(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */
        /* jshint strict: false */

        document.addEventListener("DOMContentLoaded", function () {
            var tabButtons = document.querySelectorAll('.tab-bar .tab-button');
            var currentUrl = window.location.pathname + window.location.search;

            tabButtons.forEach(function (button) {
                button.addEventListener('click', function () {
                    var isActive = button.classList.contains('active');
                    var tabUrl = button.getAttribute('data-url');

                    // Если кнопка ведёт на текущую страницу и уже активна
                    if (tabUrl === currentUrl && isActive) {
                        // Предотвращаем дальнейшие действия
                        return;
                    }

                    if (button.dataset.event !== 'go-to-app') {
                        // Показываем индикатор загрузки для неактивных вкладок
                        window.showPageLoader();
                    }

                    // Отправляем события аналитики
                    if (window.brxTracking) {
                        if (button.classList.contains('find-tour-form')) {
                            window.brxTracking.sendAnalyticsEvent('click_search_tab');
                        } else if (button.classList.contains('wishlist')) {
                            window.brxTracking.sendAnalyticsEvent('click_whishlist_tab');
                        } else if (button.classList.contains('my-tours')) {
                            window.brxTracking.sendAnalyticsEvent('click_my_tours_tab');
                        }
                    }

                    // Выполняем переход на страницу
                    window.location.href = tabUrl;
                });
            });
        });
    }, {}] }, {}, [1]);